import { render, staticRenderFns } from "./ArticleRating.vue?vue&type=template&id=569ea807&lang=pug&"
import script from "./ArticleRating.vue?vue&type=script&lang=ts&"
export * from "./ArticleRating.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleRating.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports